module.exports = __webpack_public_path__ + "static/media/tool.9820ae34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/SVG/tool.svg
// module id = 158
// module chunks = 0